import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { InPersonUrgentCareOptionCardComponent } from "../in-person-urgent-care-option-card/in-person-urgent-care-option-card.component";
import { MatButtonModule } from '@angular/material/button';
import { environment } from '../../../../../environments/environment';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslatePipe } from '@ngx-translate/core';
import { InPersonUrgentCareOptionCard } from '../../../../shared/model/getcarenow/InPersonUrgentCare';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MonitoringService } from '../../../../shared/services/monitoring/monitoring-service';

@Component({
  selector: 'app-in-person-urgent-care-mobile',
  imports: [CommonModule, TranslateModule, MatProgressSpinnerModule, MatCardModule, MatButtonModule, InPersonUrgentCareOptionCardComponent],
  templateUrl: './in-person-urgent-care.component.html',
  styleUrl: '../../../../../styles.css'
})
export class InPersonUrgentCareComponent {
  
  @Input() locale: string | null = null;
  @Input() isPlus: boolean | null = null;
  @Input() inpersonUrgentCareOptions: Array<InPersonUrgentCareOptionCard> = [];

  public title: string = 'TITLE';
  public description: string = 'DESCRIPTION';
  public showMoreText: string = 'SHOW_MORE';

  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
    this.translate.use(this.locale || 'en-US'); // Default to 'en-US' if no locale is provided
  }

  ngOnInit(): void {
    this.translate.get('INPERSONURGENTCARE.TITLE').subscribe((translated: string) => {
      this.title = translated;
    });

    this.translate.get('INPERSONURGENTCARE.DESCRIPTION').subscribe((translated: string) => {
      this.description = translated;
    });

    this.translate.get('SHOW_MORE').subscribe((translated: string) => {
      this.showMoreText = translated;
    }); 

  }

  showMeMore() {
    const eptID = sessionStorage.getItem("eptID");
    const isMobile = window.location.href.includes('mobile');

    if (eptID == null || eptID == undefined || eptID == "") {
      this.showMeMoreUnAuth(isMobile); 
    }
    else {
      this.showMeMoreAuth();
    }
  }

  showMeMoreUnAuth(isMobile: boolean) {
    // Logic to show more options or details for unauthenticated users
    var deepLink = isMobile ? environment.mobile_omw_deep_link_base_url : environment.web_unauth_omw_deep_link_base_url;
    deepLink += "?linksource=PLUAIPUC";

    this.monitoringService.logEvent('ShowMore/NoAuth', { feature: 'get-care-now', subfeature: 'IPUC', platform: isMobile ? 'mobile-plus' : 'web' }); // log as web event


    console.log("Show me more clicked (IPUC)");
    console.log(deepLink);

    window.location.href = deepLink;
  }

  showMeMoreAuth() {
    // Logic to show more options or details
    var deepLink = '';

    if (this.isPlus == null) {
      deepLink = environment.web_omw_deep_link_base_url; // For web users, use the web deep link
      this.monitoringService.logEvent('ShowMore', { feature: 'get-care-now', subfeature: 'IPUC', platform: 'web' }); // log as web event

    }
    else {
      deepLink = this.isPlus 
      ? environment.mobile_omw_deep_link_base_url // For Plus users, use the mobile deep link
      : environment.epic_omw_deep_link_base_url; //  For non-Plus users, use the epic deep link
    
      var mobilePlatform = this.isPlus ? 'mobile-plus' : 'mobile-standard';
      this.monitoringService.logEvent('ShowMore', { feature: 'get-care-now', subfeature: 'IPUC', platform: mobilePlatform });
    }

    deepLink += "?linksource=AUTHIPUCRESERVE";

    console.log("Show me more clicked (IPUC)");
    console.log(deepLink);
    
    window.location.href = deepLink;
  }
}
